import { render } from "./Tools.vue?vue&type=template&id=44bf0a79&ts=true"
import script from "./Tools.vue?vue&type=script&lang=ts"
export * from "./Tools.vue?vue&type=script&lang=ts"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__